(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vallentine-honey-world"] && !Shopify.designMode) return;
  try {
    
  function bindVallentineHoneySignup() {
    const form = document.getElementById('VallentineHoneyEarlyAccess');
    if (!form || form.dataset.klaviyoBound === 'true') return;
    const email = form.querySelector('#VallentineHoneyEmail');
    const button = form.querySelector('button[type="submit"]');
    const message = form.querySelector('#VallentineHoneyStatus');
    if (!email || !button || !message) return;
    form.dataset.klaviyoBound = 'true';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (button.disabled || !email.reportValidity()) return;
      const originalLabel = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Joining the list…';
      message.hidden = true;

      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Ydqgee', {
          method: 'POST',
          headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            'revision': '2026-07-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Vallentines Honey page waitlist',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email.value.trim(),
                      subscriptions: {
                        email: { marketing: { consent: 'SUBSCRIBED' } }
                      }
                    }
                  }
                }
              },
              relationships: {
                list: { data: { type: 'list', id: 'XpxEcR' } }
              }
            }
          })
        });
        if (!response.ok) throw new Error('Subscription request failed');
        form.querySelector('.vh-world__soon-fields').hidden = true;
        message.textContent = "You're on the list. We'll send your invitation when the next online release is ready. Jars will be offered while available.";
      } catch (error) {
        message.textContent = "We couldn't add you just now. Please try again.";
        button.disabled = false;
        button.innerHTML = originalLabel;
      }
      message.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindVallentineHoneySignup);
  } else {
    bindVallentineHoneySignup();
  }
  document.addEventListener('shopify:section:load', bindVallentineHoneySignup);

  } catch(e) { console.error(e); }
})();
})();
